import jwtDecode from "jwt-decode";
import axios from "axios";

import { login, logout } from "../pages/auth/redux/authSlice";

export function saveTokenInLocalStorage(tokens) {
  localStorage.setItem("accessToken", tokens.accessToken);
  if (tokens?.refreshToken) {
    localStorage.setItem("refreshToken", tokens.refreshToken);
  }
}

export function removeTokenFromLocalStorage() {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
}

export async function renewToken(refreshToken, callback) {
  if (!refreshToken) {
    if (typeof callback === "function") callback();
    return null;
  }

  try {
    const res = await axios.post("/rest/renewToken", {
      token: refreshToken,
    });
    if (res.status == 403) {
      localStorage.removeItem("refreshToken");
      if (typeof callback === "function") callback();
      return;
    }
    return res.data;
  } catch (error) {
    if (typeof callback === "function") callback();
  }
}

export function decodeToken(token) {
  if (token) {
    const now = Date.now();
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 >= now;
  } else {
    return false;
  }
}

export async function checkAutoLogin(dispatch, history) {
  const accessToken = localStorage.getItem("accessToken");

  const decodedAccess = decodeToken(accessToken);
  if (decodedAccess) {
    dispatch(login());
  } else {
    localStorage.removeItem("accessToken");
    const refreshToken = localStorage.getItem("refreshToken");
    const newToken = await renewToken(refreshToken, () => {
      dispatch(logout());
      history.push("/login");
    });

    if (newToken?.success) {
      const tokens = newToken.tokens;

      saveTokenInLocalStorage(tokens);
      dispatch(login());
    } else {
      removeTokenFromLocalStorage();
      dispatch(logout());
      history.push("/login");
      return;
    }
  }
}
